module.exports = __webpack_public_path__ + "static/media/certificate.a8f48c6b.jpg";